import { ISolicitationService } from './interfaces'
import { GetSolicitationMetricsUseCase } from '../useCases/SolicitationUseCases'
import { GetSolicitationMetricsUseCaseRequest } from '../useCases/interfaces'
import { Result, isOk, createOk } from '@/shared/utils/Result'

export class SolicitationService implements ISolicitationService {
  constructor(
    private readonly getSolicitationMetricsUseCase: GetSolicitationMetricsUseCase
  ) {}

  async getSolicitationMetrics(
    request: GetSolicitationMetricsUseCaseRequest
  ): Promise<
    Result<
      {
        total: number
        accepted: number
        refused: number
        canceled: number
        pending: number
        lastUpdatedAt?: string
      },
      Error
    >
  > {
    const result = await this.getSolicitationMetricsUseCase.execute(request)
    if (isOk(result)) {
      const data = result.value
      return createOk({
        total: data.totalSolicitations,
        accepted: data.acceptedSolicitations,
        refused: data.refusedSolicitations,
        canceled: data.canceledSolicitations,
        pending: data.totalSolicitations - data.acceptedSolicitations,
        lastUpdatedAt: data.lastUpdatedAt,
      })
    }

    return result
  }
}
